module.exports = __webpack_public_path__ + "static/media/debt-general-v4.6e64aa8c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/debt-general-v4.svg
// module id = 81
// module chunks = 0